// Dashboard version stamp.
//
// Bump DASHBOARD_VERSION (and the date) on every dashboard change that gets
// deployed. It renders in the sidebar footer, so the LIVE build can be verified
// at a glance — the defense against a stale local tree silently reverting what's
// already deployed. Mirrors the panel's PANEL_REVISION convention.
export const DASHBOARD_VERSION = '1.94.0';
export const DASHBOARD_BUILT = '2026-08-20';
